import Utils from './utils'
declare var setPriceDisplayTypeUrl: string;

export default class PriceHelper {
    public static isVATExPrice: boolean = false;
    public static formatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });

    constructor() {
        this.initVATExPrice();
    }

    public initVATExPrice() {
        if (!this.getPDCookieAndSetFlag()) {
            fetch(setPriceDisplayTypeUrl,
                {
                    method: 'POST'
                }
            ).then(this.getPDCookieAndSetFlag);
        }
    }

    public getPDCookieAndSetFlag(): boolean {
        var cookie = Utils.getCookie('pdt');
        if (cookie != null) {
            PriceHelper.isVATExPrice = cookie.split(',').length > 0 && cookie.split(',')[0] === "VE";
            if (PriceHelper.isVATExPrice) {
                PriceHelper.setPriceDisplay();
            }
            return true;
        }
        return false;
    }

    public static setPriceDisplay() {
        var elements = document.querySelectorAll('[data-price][data-pricevatex]');

        elements.forEach(function (el) {
            if (el != undefined) {
            var price: number = Number(el.querySelector('span')?.dataset?.price);
            var priceVATEx: number = Number(el.querySelector('span')?.dataset?.pricevatex);

            if (PriceHelper.isVATExPrice && !isNaN(priceVATEx)) {
                el.textContent = PriceHelper.formatter.format(priceVATEx);
            } else if (!PriceHelper.isVATExPrice && !isNaN(price)) {
                el.textContent = PriceHelper.formatter.format(price);
                }
            }
        });

        //For listing pages
        var isVatExelements = document.querySelectorAll('[data - isvatex]')!;

        isVatExelements.forEach(function (el) {
            el.querySelector('span')!.dataset.isvatex = String(PriceHelper.isVATExPrice)
        });
    }


    static formatPrice(price: number) {
        return PriceHelper.formatter.format(price);
    };

    static displayPrices() {
        PriceHelper.setPriceDisplay();
    }
    static excludeVAT(price: number, rate: number) {
        if (price > 0) {
            return Math.round((price / (1 + rate)) * 100) / 100;
        }
        return 0;
    }
}